
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/category/[...slug]",
      function () {
        return require("private-next-pages/agents/category/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/category/[...slug]"])
      });
    }
  